import { SettingsService } from './../settings.service';
import { SelectionOptionsRendererModule } from './selection-options-renderer/selection-options-renderer.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SelectionOptionsRoutingModule } from './selection-options-routing.module';
import { DxDataGridModule, DxTextAreaModule, DxPopupModule } from 'devextreme-angular';
import { DevEpressCommonModule } from 'src/app/dev-epress-common.module';
import { SelectionOptionsComponent } from './selection-options.component';
import { PageTitleModule } from 'src/app/components/page-title/page-title.module';

@NgModule({
  declarations: [SelectionOptionsComponent],
  imports: [
    CommonModule,
    SelectionOptionsRoutingModule,

		PageTitleModule,
		SelectionOptionsRendererModule,

    DxDataGridModule,
    DevEpressCommonModule,
    DxTextAreaModule,
    DxPopupModule
  ],
  providers: [SettingsService]
})
export class SelectionOptionsModule { }
